import { render, staticRenderFns } from "./AddressDetailsMobileModal.vue?vue&type=template&id=4d514b16"
import script from "./AddressDetailsMobileModal.vue?vue&type=script&lang=js"
export * from "./AddressDetailsMobileModal.vue?vue&type=script&lang=js"
import style0 from "./AddressDetailsMobileModal.vue?vue&type=style&index=0&id=4d514b16&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d514b16')) {
      api.createRecord('4d514b16', component.options)
    } else {
      api.reload('4d514b16', component.options)
    }
    module.hot.accept("./AddressDetailsMobileModal.vue?vue&type=template&id=4d514b16", function () {
      api.rerender('4d514b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Client/AddressDetailsMobileModal.vue"
export default component.exports